import { Colors, Services, isEmpty } from '@sigma-frontend-libs/commons'

import { icons, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Item',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    disabledNames: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    validation() {
      return Object.values(this.proxy).every(value => {
        return !isEmpty(value)
      })
    },

    activatorLabel() {
      const result = []

      if (this.proxy.advertiserId) {
        result.push(this.proxy.advertiserId)
      } else {
        result.push(this.getTranslate(`${Services.providers}.labels.senderNameToIds.empty.advertiserId`))
      }

      if (this.proxy.senderNumberId) {
        result.push(this.proxy.senderNumberId)
      } else {
        result.push(this.getTranslate(`${Services.providers}.labels.senderNameToIds.empty.senderNumberId`))
      }

      return result.join(' / ')
    },

    activatorProps() {
      let icon = icons.clear
      let iconColor = Colors.error
      if (this.validation) {
        icon = icons.check
        iconColor = Colors.success
      }

      const result = {
        value: this.proxy.sendername,
        label: this.activatorLabel,
        icon,
        iconColor,
        width: '100%',
        onClick: () => {
          return {}
        }
      }
      if (isEmpty(this.proxy.sendername)) {
        result.value = this.getTranslate(`${Services.providers}.labels.senderNameToIds.empty.sendername`)
      }

      return result
    }
  },

  render
}
